import { TextBody2, TextLabel } from "common/components";
import {
  TableWrapper,
  TableRow,
  TableHeaderCell,
  TableCell,
} from "common/components/Table/table";
import {
  PaymentChannel,
  PaymentMethod,
  PaymentStatus,
} from "common/enum/PaymentTypes";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { I18N_KEYS } from "common/i18n/keys";
import { useApiRequest } from "common/utils/api";
import { DataLoadingLayout } from "common/utils/DataLoadingLayout";
import { useTranslation } from "react-i18next";

export const SalesDetailModalBody = ({ paymentId }) => {
  const { t } = useTranslation();
  const { data, loading } = useApiRequest({
    method: REQUEST_METHOD.GET,
    url: `/api/v2.0/payment/${paymentId}`,
    queryParameter: { clubId: sessionStorage.getItem("clubId") },
  });

  const filterData = () => {
    const targetData = data?.payment;
    if (!targetData) return [];
    return [
      {
        title: t(I18N_KEYS.sales.detail.modal.table.id),
        value: targetData.paymentTrxId,
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.date),
        value: targetData.paymentAt?.replace("T", " ").slice(0, 19),
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.status),
        value: (
          <TextLabel color={PaymentStatus[targetData.status]?.color}>
            {t(PaymentStatus[targetData.status]?.text)}
          </TextLabel>
        ),
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.discountAmount),
        value: `${targetData.currency} ${Number(targetData.discountAmount).toFixed(2)}`,
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.paidAmount),
        value: `${targetData.currency} ${Number(targetData.actualAmount).toFixed(2)}`,
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.items),
        value: targetData.items?.map((i) => (
          <div style={{ margin: "0.5rem 0" }} key={i.id}>
            {i.itemName} * {i.quantity}
          </div>
        )),
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.paymentMethod),
        value: t(PaymentMethod[targetData.paymentMethod]),
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.paymentChannel),
        value: t(PaymentChannel[targetData.paymentPath]),
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.playerInfo),
        subTitle: t(I18N_KEYS.sales.detail.modal.table.sub.playerInfo),
        value: targetData.payerName,
      },
      {
        title: t(I18N_KEYS.sales.detail.modal.table.note),
        subTitle: t(I18N_KEYS.sales.detail.modal.table.sub.note),
        value: targetData.memo ?? "-",
      },
    ];
  };

  return (
    <DataLoadingLayout loading={loading}>
      <TableWrapper style={{ minWidth: "40rem" }}>
        {filterData().map((row) => (
          <TableRow>
            <TableHeaderCell width={"30%"}>
              {row.title}
              {row.subTitle && <TextBody2>{row.subTitle}</TextBody2>}
            </TableHeaderCell>
            <TableCell> {row.value}</TableCell>
          </TableRow>
        ))}
      </TableWrapper>
    </DataLoadingLayout>
  );
};
